import FormSection from 'src/shared/components/forms/FormSection/FormSection'
import FormSectionRow from 'src/shared/components/forms/FormSectionRow/FormSectionRow'
import Dropdown from 'src/shared/components/forms/selelct-dropdown/Dropdown'
import './Pago.css'
import { ExtensionEstanciaValues } from '../../EstensionEstancia-types'
import { Controller, useFormContext } from 'react-hook-form'
import { InputAbonarEasyRewards } from 'src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards'
import { PAYMENT_METHODS } from 'src/constants/payments'
import InputTextSuggestions from 'src/shared/components/forms/input-text-suggestions/InputTextSuggestions'
import { ModalidadDePago, TiposPagos, useGetColaboradoresQuery } from 'src/gql/schema'
import { useProfile } from 'src/shared/hooks/useProfile'
import accountBoxFill from 'src/shared/icons/accountBoxFill'
import ModalPagoMixtoInput from 'src/shared/components/forms/ModalPagoMixtoInput/ModalPagoMixtoInput'
import { useEffect, useRef, useState } from 'react'
import { useCosts } from '../../context/CostContext'
import { InputCardNumber } from 'src/shared/sections/payment/InputCardNumber'
import LovePointsInput from './sections/LovePointsInput/LovePointsInput'

const Pago = ({ loading }: { loading?: boolean }) => {

    const {
        control,
        watch,
        setValue
    } = useFormContext<ExtensionEstanciaValues>()

    const { costs, tarifaBaseHabitacion } = useCosts()

    const { hotel_id } = useProfile()

    const { data: colaboradores } = useGetColaboradoresQuery({
        variables: {
            hotel_id,
        },
    })

    const metodoPago = watch("pago.mainMethod")
    const tipoPago = watch("pago.type")
    const pagos = watch("pago.items")
    const [isModalPagoMixtoOpen, setisModalPagoMixtoOpen] = useState(false)
    const [isConsultingLovePointsBalance, setisConsultingLovePointsBalance] = useState(false)
    const prevMetodoPago = useRef(metodoPago)

    useEffect(() => {
        const methodChanged = prevMetodoPago.current !== metodoPago
        prevMetodoPago.current = metodoPago

        // Limpiar lista de pagos al pasar a pendiente
        if (tipoPago === ModalidadDePago.Pendiente) {
            setValue("pago.mainMethod", TiposPagos.Efectivo)
            return setValue("pago.items", [])
        }
        // Setear el primer tipo de pago del mixto al metodo de pago seleccionado inicialmente.
        // Solo cuando el método cambia a mixto, no cuando costs cambia (para no borrar pagos mixtos existentes)
        if (metodoPago === PAYMENT_METHODS.mixto.value) {
            if (!methodChanged) return
            let amount = 0
            if (pagos?.[0]?.easyReward) {
                amount = pagos?.[0]?.easyReward.saldo
            } else {
                amount = pagos?.[0]?.amount
            }
            return setValue("pago.items", [{
                amount: amount,
                method: pagos?.[0]?.method,
                number: pagos?.[0]?.number,
                colaboradorConsumoInterno: undefined,
                easyReward: pagos?.[0]?.easyReward,
                propina: undefined
            }])
        }
        // limpiar pagos mixtos / actualizar monto según costs
        let amount = 0
        if (metodoPago === TiposPagos.LovePoints) {
            amount = pagos?.[0]?.easyReward ? pagos?.[0]?.easyReward.saldo > costs.totalConIva ? costs.totalConIva : pagos?.[0]?.easyReward.saldo : 0
        } else {
            amount = costs.totalConIva
        }
        setValue("pago.items", [{
            amount,
            method: metodoPago as TiposPagos,
            number: pagos?.[0]?.number,
            colaboradorConsumoInterno: undefined,
            easyReward: metodoPago === PAYMENT_METHODS.lovePoints.value ? pagos?.[0]?.easyReward : undefined,
            propina: methodChanged ? undefined : pagos?.[0]?.propina
        }])
    }, [metodoPago, tipoPago, costs])

    useEffect(() => {
        if (metodoPago === PAYMENT_METHODS.mixto.value) {
            setisModalPagoMixtoOpen(true)
        }
    }, [metodoPago])
    

    useEffect(() => {
        if (tarifaBaseHabitacion) {
            setValue("pago.type", ModalidadDePago.Total)
            setValue("pago.mainMethod", TiposPagos.Efectivo)
        }
    }, [tarifaBaseHabitacion])


    return (
        <FormSection title="Pago">
            <FormSectionRow>
                <Controller
                    control={control}
                    name='pago.type'
                    rules={{ required: true }}
                    render={({ field: { onChange, value }, fieldState }) =>
                        <Dropdown
                            disabled={loading}
                            onClick={v => onChange(v.value)}
                            value={value}
                            errorHintText={fieldState.error?.type === "required" ? "Selecciona una opción" : ""}
                            containerClassName='renovacion-estancia__tarifa__pago__dropdown'
                            label='Tipo de pago'
                            icon='coinMoney'
                            placeholder='Selecciona una opción'
                            options={[
                                { label: "Total", value: ModalidadDePago.Total },
                                { label: "Pendiente", value: ModalidadDePago.Pendiente },
                            ]}
                        />
                    }
                />
                {
                    (tipoPago as ModalidadDePago) === ModalidadDePago.Total && <>
                        <Controller
                            control={control}
                            name='pago.mainMethod'
                            render={({ field: { onChange, value }, fieldState }) =>
                                <Dropdown
                                    onClick={v => onChange(v.value)}
                                    value={value}
                                    containerClassName='renovacion-estancia__tarifa__pago__dropdown'
                                    errorHintText={fieldState.error?.type === "required" ? "Selecciona una opción" : ""}
                                    label='Método de pago'
                                    placeholder='Selecciona una opción'
                                    icon='BankCard'
                                    options={[
                                        PAYMENT_METHODS.efectivo,
                                        PAYMENT_METHODS.visaOMasterCard,
                                        PAYMENT_METHODS.amex,
                                        PAYMENT_METHODS.depositoOTransferencia,
                                        PAYMENT_METHODS.cortesia,
                                        PAYMENT_METHODS.consumoInterno,
                                        PAYMENT_METHODS.lovePoints,
                                        PAYMENT_METHODS.mixto,
                                    ]}
                                />
                            }
                        />
                        {
                            [
                                PAYMENT_METHODS.visaOMasterCard.value,
                                PAYMENT_METHODS.amex.value,
                                PAYMENT_METHODS.depositoOTransferencia.value,
                            ].includes(metodoPago as TiposPagos) &&
                            <Controller
                                control={control}
                                name={`pago.items.0.number`}
                                rules={{
                                    required: true,
                                    minLength: 4,
                                    maxLength: 10,
                                }}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <InputCardNumber
                                        inputWrapperClass='renovacion-estancia__tarifa__pago__dropdown'
                                        onChange={onChange}
                                        value={value || ""}
                                        label={
                                            metodoPago ===
                                                PAYMENT_METHODS.depositoOTransferencia.value
                                                ? "Número de clabe o referencia"
                                                : "Número de tarjeta o referencia"
                                        }
                                        placeholder={
                                            metodoPago ===
                                                PAYMENT_METHODS.depositoOTransferencia.value
                                                ? "Ingresa número"
                                                : "Máximo 10 dígitos"
                                        }
                                        error={!!error}
                                        errorhinttext={error?.type === "minLength" ? "Ingresa mínimo 4 dígitos" : error?.type === "maxLength" ? "Ingresa máximo 10 dígitos" : error?.type === "required" ? "El campo es requerido" : ""}
                                    />
                                )}
                            />
                        }
                        {metodoPago === PAYMENT_METHODS.mixto.value ? (
                            <span
                                className="payment-mixto-method-edit__label"
                                style={{ marginTop: 32 }}
                                onClick={() => {
                                    setisModalPagoMixtoOpen(true)
                                }}
                            >
                                {"Editar"}
                            </span>
                        ) : null}
                        {
                            [
                                PAYMENT_METHODS.efectivo.value,
                                PAYMENT_METHODS.visaOMasterCard.value,
                                PAYMENT_METHODS.amex.value,
                                PAYMENT_METHODS.depositoOTransferencia.value,
                            ].includes(metodoPago as TiposPagos) && (
                                <Controller
                                    control={control}
                                    name='pago.items.0.easyReward'
                                    rules={{ maxLength: 5 }}
                                    render={({ field: { onChange, value }, fieldState: { error } }) =>
                                        <InputAbonarEasyRewards
                                            lovePointsAmount={value?.saldo || "0"}
                                            setLovePointsAmount={onChange}
                                            onChange={onChange}
                                            value={value?.id || ""}
                                            error={!!error}
                                            errorhinttext=''
                                            className='renovacion-estancia__tarifa__pago__dropdown'
                                            label='Abonar a Easyrewards (opcional)'
                                        />
                                    }
                                />
                            )
                        }
                        {
                            metodoPago === PAYMENT_METHODS.lovePoints.value &&
                            <Controller
                                control={control}
                                name="pago.items.0.easyReward"
                                rules={{ required: true }}
                                render={({ field: { onChange, value }, fieldState: { error}, formState: { isSubmitted } }) => (
                                    <LovePointsInput
                                        error={error}
                                        required={isSubmitted} totalCost={costs.totalConPropinas} value={value} onChange={onChange} openModalMixto={() => {
                                            setisConsultingLovePointsBalance(true)
                                            setValue('pago.mainMethod', PAYMENT_METHODS.mixto.value)
                                        }
                                        }
                                    />
                                )}
                            />
                        }
                        {
                            metodoPago === PAYMENT_METHODS.consumoInterno.value &&
                            <Controller
                                control={control}
                                name="pago.items.0.colaboradorConsumoInterno"
                                rules={{
                                    required: true,
                                    validate: (v) => !!v?.id && !!v?.title,
                                }}
                                render={({
                                    field: { value, onChange },
                                    fieldState: { error },
                                }) => (
                                    <InputTextSuggestions
                                        suggestionsListWidth="255px"
                                        className='renovacion-estancia__tarifa__pago__dropdown'
                                        suggestions={
                                            colaboradores?.colaboradores?.map((c) => ({
                                                title: `${c.nombre} ${c.apellido_paterno} ${c.apellido_materno}`,
                                                id: c.colaborador_id,
                                            })) || []
                                        }
                                        value={value || ""}
                                        inputTextConfig={{
                                            label: "Nombre del personal",
                                            placeholder: "Nombre del personal",
                                            type: "text",
                                            icon: accountBoxFill,
                                            error: !!error,
                                            errorhinttext:
                                                error?.type === "validate" ||
                                                    error?.type === "required"
                                                    ? "Escribe el nombre del responsable"
                                                    : "",
                                        }}
                                        onChange={onChange}
                                    />
                                )}
                            />
                        }
                        {
                            metodoPago === PAYMENT_METHODS.mixto.value && (
                                <Controller
                                    control={control}
                                    name='pago.items'
                                    render={({ field: { value, onChange } }) => (
                                        <ModalPagoMixtoInput
                                            title={isConsultingLovePointsBalance ? "Consulta de saldo y pago" : undefined}
                                            total={costs.total}
                                            visible={isModalPagoMixtoOpen}
                                            value={value}
                                            onChange={onChange}
                                            onConfirm={() => setisModalPagoMixtoOpen(false)}
                                            onClose={() => {
                                                setValue("pago.mainMethod", pagos[0].method)
                                                setisModalPagoMixtoOpen(false)
                                                setisConsultingLovePointsBalance(false)
                                            }}
                                            paymentOptions={[
                                                PAYMENT_METHODS.efectivo,
                                                PAYMENT_METHODS.visaOMasterCard,
                                                PAYMENT_METHODS.amex,
                                                PAYMENT_METHODS.depositoOTransferencia,
                                                PAYMENT_METHODS.lovePoints,
                                            ]}
                                        />
                                    )}
                                />
                            )
                        }
                    </>
                }
            </FormSectionRow>
        </FormSection>
    )
}

export default Pago